<template>
    <small class="text-info">Распечатайте заявления на вступление, подпишите его, отсканируйте/сфотографируйте и загрузите полученное изображение.</small>
</template>
<script>
export default {
}
</script>
